import { render, staticRenderFns } from "./embed-link-expand.vue?vue&type=template&id=4482bae9&scoped=true&"
import script from "./embed-link-expand.vue?vue&type=script&lang=js&"
export * from "./embed-link-expand.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4482bae9",
  null
  
)

export default component.exports